export default __webpack_public_path__ + "static/media/TM2U_Logo_250px_Width.b16d4190.svg";